<template>
  <el-form ref="form" :model="form" :rules="rules" label-position="top" :disabled="!form.isFirst || isView">
    <el-table :data="data">
      <el-table-column align="right" label="年份" prop="name" width="180" />
      <el-table-column align="center">
        <template #header>{{form[2021].year}}</template>
        <template v-slot="scope">
          <el-form-item :prop="`2021.${scope.row.key}`" :rules="rules[scope.row.key]">
            <el-input-number :controls="false" :min="scope.row.min" :max="scope.row.max" v-model="form[2021][scope.row.key]" :disabled="!form[2021].isFirst"></el-input-number>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #header>{{form[2022].year}}</template>
        <template v-slot="scope">
          <el-form-item :prop="`2022.${scope.row.key}`" :rules="rules[scope.row.key]">
            <el-input-number :controls="false" :min="scope.row.min" :max="scope.row.max" v-model="form[2022][scope.row.key]" :disabled="!form[2022].isFirst"></el-input-number>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column align="center">
        <template #header>{{form[2023].year}}</template>
        <template v-slot="scope">
          <el-form-item :prop="`2023.${scope.row.key}`" :rules="rules[scope.row.key]">
            <el-input-number :controls="false" :min="scope.row.min" :max="scope.row.max" v-model="form[2023][scope.row.key]" :disabled="!form[2023].isFirst"></el-input-number>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <el-form-item :label="`${form.monthYear}年至今数字化投入`" class="font-bold" prop="monthVal">
      <el-input v-model="form.monthVal">
        <span slot="append">万元</span>
      </el-input>
    </el-form-item>
    <el-form-item label="未来拟数字化项目投入" class="font-bold" prop="nowInvestment">
      <el-input v-model="form.nowInvestment">
        <el-date-picker slot="prepend" type="monthrange" v-model="form.proInvestment" :picker-options="options" range-separator="~" start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy年MM月" value-format="yyyy-MM"></el-date-picker>
        <span slot="append">万元</span>
      </el-input>
    </el-form-item>
    <el-form-item v-if="!isView">
      <el-button type="primary" @click="handleSave" :disabled="!form.isFirst">保存</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { addRevenueList, updateInfo } from '@/api/enterprise'

export default {
  props: ['info', 'isView'],
  data () {
    return {
      options: {
        disabledDate: (date) => {
          const now = new Date()
          return date.getFullYear() < now.getFullYear() || (date.getFullYear() === now.getFullYear() && date.getMonth() <= (now.getMonth() + 1))
        }
      },
      form: {
        isFirst: false,
        2021: {
          year: undefined,
          propertyCount: undefined,
          taxes: undefined,
          personCount: undefined,
          digitCount: undefined,
          personRevenue: undefined,
          profit: undefined,
          digitInput: undefined,
          isFirst: false
        },
        2022: {
          year: undefined,
          propertyCount: undefined,
          taxes: undefined,
          personCount: undefined,
          digitCount: undefined,
          personRevenue: undefined,
          profit: undefined,
          digitInput: undefined,
          isFirst: false
        },
        2023: {
          year: undefined,
          propertyCount: undefined,
          taxes: undefined,
          personCount: undefined,
          digitCount: undefined,
          personRevenue: undefined,
          profit: undefined,
          digitInput: undefined,
          isFirst: false
        }
      },
      data: [
        {
          name: '资产总额（万元）',
          key: 'propertyCount',
          min: -Infinity,
          max: Infinity
        },
        {
          name: '负债率（％）',
          key: 'debt',
          min: -100,
          max: 100
        },
        {
          name: '实缴税金（万元）',
          key: 'taxes',
          min: 0,
          max: Infinity
        },
        {
          name: '从业人员（人）',
          key: 'personCount',
          min: 0,
          max: Infinity
        },
        {
          name: '从事数字化人员（人）',
          key: 'digitCount',
          min: 0,
          max: Infinity
        },
        {
          name: '营业收入（万元）',
          key: 'personRevenue',
          min: -Infinity,
          max: Infinity
        },
        {
          name: '利润（万元）',
          key: 'profit',
          min: -Infinity,
          max: Infinity
        },
        {
          name: '该年数字化转型投入（万元）',
          key: 'digitInput',
          min: -Infinity,
          max: Infinity
        }
      ],
      rules: {
        isDigital: {},
        investmentAmount: [
          { required: true, message: '请输入有效的投入金额', trigger: 'blur' },
          {
            validator: (rule, value, cb) => {
              if (!this.form.isDigital) {
                cb()
                return
              }
              if (value) {
                cb()
              } else {
                cb(new Error('请输入有效的投入金额'))
              }
            }
          }
        ],
        planDate: [
          { required: true, message: '请选择有效的计划完成时间', trigger: 'blur' },
          {
            validator: (rule, value, cb) => {
              if (!this.form.isDigital) {
                cb()
                return
              }
              if (value) {
                cb()
              } else {
                cb(new Error('请选择有效的计划完成时间'))
              }
            }
          }
        ],
        howMonth: [
          {
            required: true, message: '请选择月份', trigger: 'blur'
          }
        ],
        monthVal: [
          {
            validator: (rule, value, cb) => {
              if (!this.form.isDo) {
                cb()
                return
              }
              if (value) {
                cb()
              } else {
                cb(new Error('请输入有效的数字化转型投入'))
              }
            }
          }
        ],
        nowInvestment: [],
        propertyCount: [
          { required: true, min: -Infinity, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        debt: [
          { required: true, min: -100, max: 100, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        taxes: [
          { required: true, min: 0, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        personCount: [
          { required: true, min: 0, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        digitCount: [
          { required: true, min: 0, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        personRevenue: [
          { required: true, min: -Infinity, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        profit: [
          { required: true, min: -Infinity, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ],
        digitInput: [
          { required: true, min: -Infinity, max: Infinity, type: 'number', message: '无效的数字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.form = Object.assign({}, this.form, this.transInfoToForm(Object.assign({ revenue: [] }, this.info)))
    console.log('form', this.form)
  },
  methods: {
    transInfoToForm (data) {
      const [year, monthVal] = Object.entries(JSON.parse(data.newMonthData || '{}')).map(([k, v]) => [k.replace('year', ''), v])[0] || []
      const [y2021, y2022, y2023] = data.revenue
      y2021.isFirst = isInchoateRevenue(y2021)
      y2022.isFirst = isInchoateRevenue(y2022)
      y2023.isFirst = isInchoateRevenue(y2023)
      const isFirst = y2021.isFirst || y2022.isFirst || y2023.isFirst
      return {
        isDigital: data.isDigital || 1,
        investmentAmount: data.investmentAmount,
        planDate: data.planDate || '',
        howMonth: data.howMonth || '',
        isDo: data.isDo,
        investment: data.investment,
        nowInvestment: data.nowInvestment,
        proInvestment: JSON.parse(data.proInvestment || '[]'),
        monthYear: year || (y2023.year * 1 + 1),
        monthVal,
        isFirst,
        ...{ 2021: y2021, 2022: y2022, 2023: y2023 }
      }
    },
    transFormToInfo (data) {
      return {
        isDigital: data.isDigital,
        isDo: data.isDo,
        investment: data.investment,
        nowInvestment: data.nowInvestment,
        proInvestment: JSON.stringify(data.proInvestment),
        investmentAmount: data.investmentAmount,
        planDate: data.planDate,
        howMonth: data.howMonth,
        enterpriseScale: data.enterpriseScale,
        newMonthData: JSON.stringify({ [`year${data.monthYear}`]: data.monthVal }),
        direction: JSON.stringify({
        }),
        ...{ revenue: [data[2021], data[2022], data[2023]] }
      }
    },
    handleSave () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$confirm('营收数据影响问卷选项，提交后不可再更改，确认提交吗?', '提示', {
            confirmButtonText: '提交',
            cancelButtonText: '取消',
            showClose: true,
            type: 'warning'
          }).then(() => {
            if (this.form[2023].personCount <= 20) {
              this.form.enterpriseScale = '微型企业'
            } else if (this.form[2023].personCount > 20 && this.form[2023].personCount <= 100) {
              this.form.enterpriseScale = '小型企业'
            } else if (this.form[2023].personCount > 100) {
              this.form.enterpriseScale = '中型企业'
            }
            const data = this.transFormToInfo(this.form)
            Promise.all([updateInfo(Object.assign({}, this.info, data))].concat([this.form[2021], this.form[2022], this.form[2023]].filter(v => v.isFirst).map(v => addRevenueList(v)))).then(() => {
              this.form.isFirst = false
              this.$message.success('保存成功')
              this.$emit('save', data)
            })
          })
        }
      })
    }
  }
}

function isInchoateRevenue (v) {
  return (v.propertyCount ?? null) === null || (v.taxes ?? null) === null || (v.personCount ?? null) === null || (v.digitCount ?? null) === null || (v.personRevenue ?? null) === null || (v.profit ?? null) === null || (v.digitInput ?? null) === null
}
</script>
